import { useNavigate } from 'react-router-dom';
import { MODULE_CATALOG } from '@vce/shared';
import { useAuth } from '@/app/auth-context';
import { Button } from '@/components/ui/primitives';

/** Texto quando o usuário não tem o módulo `runs` e não deve ver CTA para /runs. */
export const NO_RUNS_MODULE_HINT = 'Peça a um gestor para gerar sugestões';

/**
 * CTA condicional para Execuções: botão só se `hasModule('runs')`.
 * Sem o módulo, empty states usam {@link NO_RUNS_MODULE_HINT} e sem botão.
 */
export function useRunsModuleCta() {
  const { hasModule } = useAuth();
  const navigate = useNavigate();
  const hasRuns = hasModule('runs');

  return {
    hasRuns,
    description(withAccess: string): string {
      return hasRuns ? withAccess : NO_RUNS_MODULE_HINT;
    },
    action(label = `Ir para ${MODULE_CATALOG.runs.label}`, className?: string) {
      if (!hasRuns) return undefined;
      return (
        <Button
          variant="primary"
          size="sm"
          className={className}
          onClick={() => navigate(MODULE_CATALOG.runs.path)}
        >
          {label}
        </Button>
      );
    },
  };
}
